import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { likeSpot, unlikeSpot, checkinSpot, removeCheckinSpot } from 'store/slices/spots';
import { Spot } from 'domain/Spot';

interface Props {
    spot: Spot;
}

const SpotSocialBar = ({ spot }: Props) => {
    const dispatch = useAppDispatch();
    const auth = useAppSelector((state) => state.auth);
    const isLoggedIn = !!auth.jwt;

    const handleLike = () => {
        if (!spot.id) return;
        if (spot.likedByCurrentUser) {
            void dispatch(unlikeSpot({ idSpot: spot.id }));
        } else {
            void dispatch(likeSpot({ idSpot: spot.id }));
        }
    };

    const handleCheckin = () => {
        if (!spot.id) return;
        if (spot.checkedInByCurrentUser) {
            void dispatch(removeCheckinSpot({ idSpot: spot.id }));
        } else {
            void dispatch(checkinSpot({ idSpot: spot.id }));
        }
    };

    return (
        <Box display="flex" alignItems="center" gap={2} py={1}>
            <Tooltip title={isLoggedIn ? (spot.likedByCurrentUser ? 'Unlike' : 'Like') : 'Log in to like'}>
                <span>
                    <Button
                        size="small"
                        variant="text"
                        onClick={handleLike}
                        disabled={!isLoggedIn}
                        startIcon={spot.likedByCurrentUser ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />}
                    >
                        <Typography variant="body2">{spot.likeCount ?? 0}</Typography>
                    </Button>
                </span>
            </Tooltip>
            <Tooltip title={isLoggedIn ? (spot.checkedInByCurrentUser ? 'Remove fly-through' : 'I\'ve flown this!') : 'Log in to check in'}>
                <span>
                    <Button
                        size="small"
                        variant="text"
                        onClick={handleCheckin}
                        disabled={!isLoggedIn}
                        startIcon={<FlightTakeoffIcon color={spot.checkedInByCurrentUser ? 'primary' : 'inherit'} />}
                    >
                        <Typography variant="body2">{spot.checkinCount ?? 0} flown</Typography>
                    </Button>
                </span>
            </Tooltip>
        </Box>
    );
};

export default SpotSocialBar;
